import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getClassAssignments } from '../../api/class';

const Events = ({ user, cid }) => {
    const [assignments, setAssignments] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getClassAssignments(cid)
            .then(res => {
                setLoading(false)
                setAssignments(res.data)
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
            })
    }, [])

    return (
        <div className="my-class-all-assignments-div">
            <div style={{ marginTop: '30px' }} className="my-class-all-assignments">
                {
                    loading ? <h1>loading</h1> :
                        (
                            (assignments && assignments.length) ? (assignments.map((each, i) => {
                                return (
                                    <div key={i} style={{ maxWidth: '400px', margin: '3px auto' }} className="card">
                                        <div className="card-header"> {each.title} </div>
                                        <div className="card-body">
                                            <blockquote className="blockquote mb-0">
                                                <p>{each.message}</p>
                                                <footer className="blockquote-footer">{each.sent_by.name}
                                                    {/* <cite className="float-end">{timeSince(new Date(each.time))}</cite> */}
                                                </footer>
                                                {(each.docs && each.docs.length) ? each.docs.map((eachDoc, i) => {
                                                    console.log(eachDoc.url)
                                                }) : ''
                                                }
                                            </blockquote>
                                        </div>
                                    </div>
                                )
                            }
                            )
                            ) : ''
                        )
                }
            </div>
        </div>
    );
};

export default Events;